<template>
  <div class="wrapper">
    <div class="tilte-text"> 会员排名 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <span class="search-label">会员昵称</span>
        <Input v-model="searchOrderForm.nickName" placeholder="会员昵称" style="width: 150px;" />
      </template>
      <template>
        <Button type="text" class="search-btn margin-left-20" @click="getOrderList">查询</Button>
      </template>
    </div>
    <div class="table-wrapper">
      <Table border
             :columns="orderColumns"
             :data="orderList"
             :loading="listLoading"
      >
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="totalOrder"
              :current="searchOrderForm.pageNo"
              show-sizer
              show-elevator
              show-total
              @on-change="changePageOrder"
              @on-page-size-change="changePagesizeOrder"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlatformUuidKfc } from '@/utils/auth'
import { Table, Button, Input, RadioGroup, Radio, Page } from 'view-design'
import { numFormatter } from '@/utils/date'
import sort from '@/javaApi/kfc/sort'
const sortModel = new sort()
export default {
  name: "Sort",
  components: {
    Table,
    Button,
    Input,
    RadioGroup,
    Radio,
    Page
  },
  data: function() {
    return {
      listLoading: false,
      totalOrder: 0,
      orderList:[],
      searchOrderForm: {
        pageNo: 1,
        pageSize: 10,
        id: undefined,
      },
      orderColumns:[
        {
          title: '排名',
          key: 'sequence'
        },
        {
          title: '会员昵称',
          key: 'nickName'
        },
        {
          title: '订单数量',
          key: 'orderCount'
        },
        {
          title: '注册时间',
          key: 'createTime'
        }
      ],
      totalProfit: 0,
      platformUuid: getPlatformUuidKfc(),
    }
  },
  created() {
    //订单排名
    this.getOrderList();
  },
  methods: {
    getOrderList(){
      let userParam = this.searchOrderForm;
      this.listLoading = true
      let that = this
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if(!condition){
        userParam.platformUuid =  this.platformUuid
      }
      userParam = this.formateInit(userParam)
      if(userParam.id){
        userParam.id = numFormatter(userParam.id)
      }
      that.listLoading = false
      sortModel.getOrderList(userParam).then(response=>{
        let res = response.data
        if(res.code === 200){
          that.listLoading = false
          that.orderList = res.data?res.data.list:[]
          that.orderList = that.formateData(that.orderList, userParam.pageNo, userParam.pageSize)
          that.totalOrder = res.data.total;
        }else{
          that.listLoading = false
          // let message = res.message?res.message:'系统繁忙请稍后再试！'
          // this.$message.error(message)
        }
      }).catch(error=>{
        that.listLoading = false
        if(error != 'token invalid'){
          this.$message.error('系统繁忙请稍后再试!')
        }
      })
    },
    formateInit(formData){
      let objCopy = {};
      for(let key in formData){
        if(formData[key]){
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
    formateData(data, pageNo, pageSize){
      if(!data){
        return []
      }
      if(!data.length){
        return []
      }
      let i = 0;
      for(i=0;i<data.length;i++){
        data[i].sequence = (i+1)+(pageNo - 1)*pageSize
      }
      return  data
    },
    changePageOrder(value){
      this.searchOrderForm.pageNo = value
      this.getOrderList()
    },
    changePagesizeOrder(value){
      this.searchOrderForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if(this.searchOrderForm.pageNo == 1){
        this.getOrderList()
      }
    },
  }
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  font-size: 12px;
}
.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}
.wrapper .table-wrapper {
  margin-top: 30px;
}
.search-wrap .ivu-icon-ios-arrow-down:before{
  color: #232323;
  content: "\F33D";
}
.ivu-date-picker-rel {
  margin: 11px 0;
}
.ivu-table{
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
}
.table-wrapper .ivu-table-header th {
  background-color: #FCFAF8 !important;
}
.table-wrapper .ivu-table-header th .ivu-table-cell{
  color: #222222 !important;
}
.table-wrapper .ivu-table-wrapper-with-border{
  border: none;
}
.table-wrapper .ivu-table-wrapper-with-border{
  border-radius: 0px;
  border-color: #FFFFFF !important;
}
.ivu-table td.color-blue .ivu-table-cell{
  color: #3A94F2;
}
</style>




// WEBPACK FOOTER //
// src/views/pc/kfc/sort/Index.vue